import { z } from "zod";
import { EntityBase, Name } from "./common.js";
import { Id } from "./ids.js";

/** Sites (kitchens, hall, serving points) and their stations; all manager-editable (DL-055, ADR-15). */

export const SiteKind = z.enum(["kitchen", "hall", "serving-point"]);

export const Site = EntityBase.extend({
  name: Name,
  kind: SiteKind,
  /** Inactive sites keep their history but get no new work (e.g. the former governorate kitchen). */
  active: z.boolean(),
});
export type Site = z.infer<typeof Site>;

export const Station = EntityBase.extend({
  siteId: Id,
  name: Name,
  sortOrder: z.int().nonnegative(),
});
export type Station = z.infer<typeof Station>;
